<template>
  <div id="sistem-pengawasan">

    <banner
      title="Sistem Pengaduan"
      description="Laporkan masalah terkait buku pelajaran Kemendikbud disini. Setiap laporan sangat berguna untuk meningkatkan kualitas buku Pelajaran Sekolah"
      :breadcrumbs="breadcrumbs"
      :icon="require('@/assets/sistem-pengawasan/decoration/Vector.svg')"
    />

    <section id="content" class="px-1 px-lg-5 pt-0">
      <div class="card shadow-sm border-0 p-4">
        <div class="timeline align-items-center align-items-lg-stretch mx-auto py-4" style="margin-top: -8%;width: 85%;">
          <div class="timeline-step active">
              <div class="step-number">1</div>
              <div class="step-content">
                  <h3>Tulis Laporan</h3>
                  <p>Tuliskan rincian keluhan Anda</p>
              </div>
          </div>
          <div class="timeline-step">
              <div class="step-number">2</div>
              <div class="step-content">
                  <h3>Proses Verifikasi</h3>
                  <p>Laporan Anda akan diproses oleh pihak berwenang</p>
              </div>
          </div>
          <div class="timeline-step">
              <div class="step-number">3</div>
              <div class="step-content">
                  <h3>Proses Tindak Lanjut</h3>
                  <p>Laporan Anda ditindaklanjuti dan dikembalikan</p>
              </div>
          </div>
          <div class="timeline-step">
              <div class="step-number">4</div>
              <div class="step-content">
                  <h3>Beri Tanggapan</h3>
                  <p>Anda dapat memberi tanggapan tentang Laporan yang dikembalikan</p>
              </div>
          </div>
          <div class="timeline-step">
              <div class="step-number">5</div>
              <div class="step-content">
                  <h3>Selesai</h3>
                  <p>Laporan akan ditindaklanjuti hingga selesai</p>
              </div>
          </div>
        </div>

        <div class="p-3 bg-primary-50 d-flex flex-column flex-lg-row justify-content-between align-items-center rounded my-3" style="gap:1rem">
          <h5 class="mb-0">Pastikan Anda memiliki semua informasi yang diperlukan sebelum memulai pengaduan. <b>Data pribadi</b> anda akan terjamin kerahasiaannya, jangan ragu untuk melaporkan isu terkait buku dan perbukuan secara umum.</h5>
          <!-- <a href="https://www.youtube.com/@sisteminformasiperbukuanin795" target="_blank" class="btn rounded bg-primary text-white px-3 py-2">
            <img src="@/assets/sistem-pengawasan/icon/tv-play.svg" class="mr-1" alt="">
            Tonton Tata Cara Pangaduan
          </a> -->
        </div>

        <div class="position-relative">
          <div v-show="!isLoggedIn" class="h-100 w-100 position-absolute rounded" style="z-index: 100;background: rgba(0, 0, 0, 0.5);">
            <div class="d-flex flex-column align-items-center mt-5">
              <i class="fas fa-fw fa-lock text-white mb-3" style="font-size: 5rem;"></i>
              <div v-show="!isLoggedIn" class="alert alert-warning">Silahkan untuk <router-link :to="`/login?callback=${callback}`" class="badge badge-primary py-1 px-2">login</router-link> terlebih dahulu untuk membuat laporan</div>
            </div>
          </div>
          <form @submit.prevent="submitReport" :class="`position-relative ${!isLoggedIn ? 'p-3' : ''}`">
            <h5 class="my-3 font-weight-bold">Data Identitas</h5>
            <div class="row">
              <div class="col-lg-6 mb-2">
                <div class="form-group">
                  <label for="fullname" class="form-label">Nama Lengkap <span class="text-danger">*</span></label>
                  <input
                    v-model="report.pelapor"
                    id="fullname"
                    type="text"
                    class="form-control"
                    placeholder="Masukkan nama lengkap"
                    required
                  />
                </div>
              </div>
              <div class="col-lg-6 mb-2">
                <div class="form-group">
                  <label for="domisili" class="form-label">Domisili <span class="text-danger">*</span></label>
                  <textarea id="domisili" class="form-control" placeholder="Masukkan alamat tempat tinggal kamu sekarang" v-model="report.domisili"></textarea>
                </div>
              </div>
              <div class="col-lg-6 mb-2">
                <div class="form-group">
                  <label for="provinsi" class="form-label">Provinsi <span class="text-danger">*</span></label>
                  <vue-select :options="provinces" label="name" placeholder="Cari provinsi" :reduce="province => province.id" :loading="loading.province" @input="getCity"></vue-select>
                </div>
              </div>
              <div class="col-lg-6 mb-2">
                <div class="form-group">
                  <label for="kota" class="form-label">Kota <span class="text-danger">*</span></label>
                  <vue-select v-model="report.kota" :options="cities" label="name" placeholder="Cari kota/kabupaten" :reduce="city => city.name" :loading="loading.city"></vue-select>
                </div>
              </div>
              <div class="col-lg-6 mb-2">
                <div class="form-group">
                  <label for="pekerjaan" class="form-label">Status <span class="text-danger">*</span></label>
                  <select class="form-control" id="pekerjaan" v-model="report.pekerjaan">
                    <option value="Guru">Guru</option>
                    <option value="Siswa">Siswa</option>
                    <option value="Masyarakat">Masyarakat</option>
                    <option value="Dinas">Dinas</option>
                    <option value="Orangtua">Orangtua</option>
                    <option value="Lain-lain">Lain-lain</option>
                  </select>
                </div>
              </div>
              <div class="col-lg-6 mb-2">
                <div class="form-group">
                  <label for="contact" class="form-label">Kontak <span class="text-danger">*</span></label>
                  <input
                    v-model="report.telepon"
                    id="contact"
                    type="text"
                    class="form-control"
                    placeholder="Misalnya nomor whatsapp"
                    required
                  />
                  <div class="text-small mt-2">Catatan : Kami butuhkan untuk umpan balik.</div>
                </div>
              </div>
              <div class="col-lg-6 mb-2">
                <div class="form-group">
                  <label for="email" class="form-label">Email <span class="text-danger">*</span></label>
                  <input
                    v-model="report.email"
                    id="email"
                    type="email"
                    class="form-control"
                    placeholder="Masukkan email"
                    required
                  />
                </div>
              </div>
            </div>
            <h5 class="my-3 font-weight-bold">Data Laporan</h5>
            <div class="row">
              <div class="col-lg-6 mb-2">
                <div class="form-group">
                  <label for="judulLaporan" class="form-label">Judul Laporan <span class="text-danger">*</span></label>
                  <input
                    v-model="report.judul"
                    id="judulLaporan"
                    type="text"
                    class="form-control"
                    placeholder="Masukkan judul laporan"
                    required
                  />
                </div>
              </div>
              <div class="col-lg-6 mb-2">
                <div class="form-group">
                  <label for="jenis-buku" class="form-label">Jenis Buku <span class="text-danger">*</span></label>
                  <select class="form-control" id="jenis-buku" v-model="report.jenis_buku" @change="handleJenisBukuChange">
                    <option value="Buku Teks Utama">Buku Teks Utama</option>
                    <option value="Buku Teks Pelajaran">Buku Teks Pelajaran</option>
                    <option value="Buku Nonteks">Buku Nonteks</option>
                  </select>
                </div>
              </div>
              <div class="col-lg-6 mb-2">
                <div class="form-group">
                  <label for="jenjang" class="form-label">Jenjang <span class="text-danger">*</span></label>
                  <select class="form-control" id="jenjang" v-model="report.jenjang" @change="getBooks($event)">
                    <option value="">Pilih jenjang</option>
                    <template v-if="report.jenis_buku === 'Buku Nonteks'">
                      <option value="level_a">Pembaca Dini A</option>
                      <option value="level_b">Pembaca Awal B1</option>
                      <option value="level_b">Pembaca Awal B2</option>
                      <option value="level_b">Pembaca Awal B3</option>
                      <option value="level_c">Pembaca Semenjana C</option>
                      <option value="level_d">Pembaca Madya D</option>
                      <option value="level_e">Pembaca Mahir E</option>
                    </template>
                    <template v-else>
                      <option value="level_paud">PAUD</option>
                      <option value="level_sd">SD/MI</option>
                      <option value="level_smp">SMP/MTS</option>
                      <option value="level_sma">SMA/MA/SMK/MAK</option>
                    </template>
                  </select>
                </div>
              </div>
              <div class="col-lg-6 mb-2" v-if="report.jenis_buku !== 'Buku Nonteks'">
                <div class="form-group">
                  <label for="kelas" class="form-label">Kelas <span class="text-danger">*</span></label>
                  <select class="form-control" id="kelas" v-model="report.kelas">
                    <option disabled value="">Pilih kelas</option>
                    <option v-for="kelas in filteredKelas" :key="kelas" :value="kelas">
                      {{ kelas }}
                    </option>
                  </select>
                  <small>Daftar kelas akan tampil setelah memilih jenjang</small>
                </div>
              </div>
              <div class="col-lg-6 mb-2">
                <div class="form-group">
                  <label for="buku" class="form-label">Buku <span class="text-danger">*</span></label>
                  <vue-select v-model="report.buku" :options="books" label="title" placeholder="Cari buku.." :reduce="book => book.title" :loading="loading.book"></vue-select>
                  <small>Daftar buku akan tampil setelah memilih jenjang</small>
                </div>
              </div>
              <div class="col-lg-6 mb-2">
                <div class="form-group">
                  <label for="masalah" class="form-label">Masalah <span class="text-danger">*</span></label>
                  <select v-model="report.kategori" class="form-control" id="masalah">
                    <option value="Kualitas Cetak">Kualitas Cetak</option>
                    <option value="Distribusi">Distribusi</option>
                    <option value="Harga Eceran Tertinggi (HET)">Harga Eceran Tertinggi (HET)</option>
                    <option value="Pengadaan">Pengadaan</option>
                    <option value="Salah Cetak">Salah Cetak</option>
                    <option value="Bahasa">Bahasa</option>
                    <option value="Kualitas Konten">Kualitas Konten</option>
                    <option value="Legalitas">Legalitas</option>
                    <option value="Kesesuaian Kurikulum">Kesesuaian Kurikulum</option>
                    <option value="Penggunaan Buku">Penggunaan Buku</option>
                    <option value="Kelengkapan Buku">Kelengkapan Buku</option>
                    <option value="Lainnya">Lainnya</option>
                  </select>
                </div>
              </div>
              <div class="col-lg-12 mb-2">
                <div class="form-group">
                  <label for="deskripsi" class="form-label">Jelaskan masalah yang terjadi dengan lengkap <span class="text-danger">*</span></label>
                  <textarea
                    v-model="report.isi"
                    id="deskripsi"
                    class="form-control"
                    placeholder="Masukkan deskripsi masalah"
                    rows="5"
                    required
                  ></textarea>
                </div>
              </div>
              <div class="col-lg-12 mb-2">
                <div class="form-group">
                  <label for="lampiran" class="form-label">Lampiran Bukti Pendukung</label>
                  <FileUploader
                    @select-file="setFile($event, 'lampiran')"
                    :uploaded="report.lampiran"
                    id="lampiran"
                  />
                  <!-- <div v-if="loading.lampiran" class="progress my-3">
                    <div class="progress-bar bg-success" role="progressbar" :style="{width: `${uploadPercentage}%`}" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100">{{ uploadPercentage }}%</div>
                  </div> -->
                  <div class="text-muted small mt-2">
                    Format <b>PDF, JPG, PNG</b> Ukuran Maks 1 Mb
                  </div>
                </div>
                <div class="my-1">
                  <button
                    v-if="!loading.lampiran"
                    @click="uploadingFile('lampiran')"
                    type="button"
                    class="btn btn-primary w-100 btn-sm"
                    id="uploadLampiran"
                  >
                    Unggah
                  </button>
                  <div v-else class="progress-wrapper my-3">
                    <div class="progress-icon">
                      <!-- Icon Document (You can replace this with an SVG or FontAwesome icon) -->
                      <i class="fas fa-file-alt"></i>
                    </div>
                    <div class="progress-bar-container">
                      <div class="progress-bar" :style="{width: `${uploadPercentage}%`}"></div>
                    </div>
                    <span class="progress-percentage">{{ uploadPercentage }}%</span>
                  </div>
                </div>
              </div>
              <div class="col-lg-6 mb-2">
                <div class="form-group">
                  <label for="tautan" class="form-label">Tautan</label>
                  <input
                    v-model="report.tautan"
                    id="tautan"
                    type="text"
                    class="form-control"
                    placeholder="Masukan tautan (jika ada)"
                  />
                  <small class="mt-2 d-block">Catatan : Jika bukti pendukung berupa video atau tautan sebuah situs, silahkan cantumkan dari platform seperti Google Drive, One Drive, Terrabox, dan lain-lain.</small>
                </div>
              </div>
              <div class="col-12 mb-3">
                <div class="form-check">
                  <input
                    class="form-check-input"
                    @change="!report.accept_tnc"
                    v-model="report.accept_tnc"
                    type="checkbox"
                    id="accept"
                  />
                  <label class="form-check-label" for="accept">
                    Saya menyetujui syarat dan ketentuan yang berlaku. <span class="text-danger">*</span>
                  </label>
                </div>
              </div>
            </div>
            <div class="d-flex justify-content-end">
              <button class="btn btn-outline-secondary px-5 mr-3">Batal</button>
              <button type="submit" class="btn btn-secondary px-4">
                <div v-if="loading.submit" class="spinner-border" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
                <span v-else>Kirim data</span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>

    <section id="content" class="px-3 px-lg-5 py-5 mt-10 bg-secondary-30 position-relative">
      <div class="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h2 class="text-dark">Laporan Terbaru</h2>
          <h5 class="text-muted">Temukan laporan terbaru dari pengguna disini</h5>
        </div>
        <div class="d-flex mr-4">
          <div role="button" class="bg-secondary mr-3 d-flex align-items-center justify-content-center rounded-circle text-white h5" style="width: 2rem; height: 2rem;" @click="prevSlide">&#10094;</div>
          <div role="button" class="bg-secondary d-flex align-items-center justify-content-center rounded-circle text-white h5" style="width: 2rem; height: 2rem;" @click="nextSlide">&#10095;</div>
        </div>
      </div>

      <div class="swiper-container position-relative">
        <div class="swiper-wrapper d-flex">
          <div class="swiper-slide card p-3 m-2" v-for="(report, index) in reports" :key="index">
            <router-link :to="`/sistem-pengawasan/laporan/${report.id}`" class="text-dark">
              <div class="d-flex align-items-center mb-3">
                <img :src="`https://ui-avatars.com/api/?name=${report.pelapor}&background=344054&color=fff&font-size=0.40`" class="rounded-circle" alt="Profile Picture" width="50" height="50" style="object-fit: cover">
                <div class="ml-2">
                    <h5 class="mb-0">{{ report.pelapor }}</h5>
                    <small class="text-muted">{{ report.created_at }}</small>
                </div>
              </div>
              <h4>{{ report.judul }}</h4>
              <p>{{ report.isi }}</p>
              <div class="d-flex align-items-center bg-primary-30 rounded p-3">
                <div :class="`btn btn-sm mr-3 ${report.status == 'Terkirim' ? 'btn-secondary' : 'text-primary'}`"><i class="fa-regular fa-circle-check"></i> Terverifikasi</div>
                <div :class="`btn btn-sm mr-3 ${report.status == 'Selesai' ? 'btn-secondary' : 'text-primary'}`"><i class="fa-regular fa-file-alt"></i> Tindak Lanjut</div>
                <!-- <div class="text-primary mr-3"><i class="fa-regular fa-comments"></i> Komentar</div>
                <div class="text-primary"><i class="fa-regular fa-thumbs-up"></i> Dukungan</div> -->
              </div>
            </router-link>
          </div>
        </div>
      </div>

    </section>

    <section  id="content" class="px-3 px-lg-5 mt-10 py-5 bg-primary-20 position-relative" style="height: 500px;">
      <h1 class="font-weight-bold mb-3">Pelajari Tata Cara Pengaduan</h1>
      <p class="lead text-muted">Buat laporan menjadi lebih mudah dengan memahami tata cara pengaduan</p>
      <img src="@/assets/sistem-pengawasan/decoration/chat.svg" class="position-absolute" style="bottom: 0;right: 0;" alt="Chat">
    </section>

    <div class="row px-2 justify-content-between" style="margin-top: -23%;">
      <div class="col-lg-6">
        <img src="@/assets/sistem-pengawasan/tata-cara-pengaduan.png" class="w-100" alt="Tata cara pengaduan">
      </div>
      <div class="col-lg-6">
        <img src="@/assets/sistem-pengawasan/stats.png" class="mt-5" alt="Stats">
        <h1 class="display-4 text-primary font-weight-bold">{{ totalReports }}</h1>
        <h3 class="text-muted">Jumlah Laporan Saat Ini</h3>
      </div>
    </div>

    <section id="content" class="mt-4 px-3 px-lg-5">
      <h1 class="tfont-weight-bold mt-5">FAQ</h1>
      <p class="lead">Temukan pertanyaan yang sering ditanyakan pada sistem pengawasan</p>
      
      <div class="row">
        <div class="col-lg-6">
          <div class="card border-0 shadow-sm p-4 mb-3">
            <div class="d-flex">
              <i class="fas fa-fw fa-question-circle text-primary h2"></i>
              <div class="ml-3">
                <h4 class="text-dark mb-0">Apakah identitas pelapor dirahasiakan?</h4>
                <p class="lead text-muted">Ya</p>
              </div>
            </div>
          </div>
          <div class="card border-0 shadow-sm p-4 mb-3">
            <div class="d-flex">
              <i class="fas fa-fw fa-hourglass-half text-danger h2"></i>
              <div class="ml-3">
                <h4 class="text-dark mb-0">Berapa lama tanggapan akan direspon?</h4>
                <p class="lead text-muted">Tergantung dari tindak lanjut setiap laporan. Contoh: Typo pada buku akan diperbaiki pada dalam tahap penyusunan buku setahun 2 kali</p>
              </div>
            </div>
          </div>
          <div class="card border-0 shadow-sm p-4 mb-3">
            <div class="d-flex">
              <i class="fas fa-fw fa-eye text-warning h2"></i>
              <div class="ml-3">
                <h4 class="text-dark mb-0">Apakah saya dapat memantau progress pelaporan?</h4>
                <p class="lead text-muted">Ya, simpan baik-baik nomor laporan anda sebagai bukti pelaporan</p>
              </div>
            </div>
          </div>
          <div class="card border-0 shadow-sm p-4 mb-3">
            <div class="d-flex">
              <i class="fa fa-fw fa-user text-secondary h2"></i>
              <div class="ml-3">
                <h4 class="text-dark mb-0">Siapa saja yang dapat mengajukan laporan?</h4>
                <p class="lead text-muted">Guru, Siswa, dan Masyarakat Umum</p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <img src="@/assets/sistem-pengawasan/apa-itu-sistem-pengawasan.png" class="w-100" alt="Image">
        </div>
      </div>
    </section>
    
  </div>
</template>

<script>

import Banner from "../../components/homepage/Banner.vue";
import FileUploader from "../../components/global/dashboard/FileUploader.vue";
import Swal from "sweetalert2";
import { mapActions, mapGetters } from "vuex"
import axios from "axios";
import { BASE_URL } from "../../store";
import { VueSelect } from "vue-select";
import _ from "lodash";

export default {
  components: { Banner, FileUploader, VueSelect },
  data() {
    return {
      API_KEY: "a0a39455c89dadd653f4a0f4a1748df3aa5c92448396881214a47d90547494fa",
      callback: "sistem-pengawasan",
      API_LOCATION: "https://api.binderbyte.com",
      provinces: [],
      cities: [],
      isLoggedIn: false,
      currentIndex: 0,
      books: [],
      reports: [],
      totalReports: 0,
      bookFromSlug: null,
      skipKelasAutoFill: false,
      report: {
        judul: "",
        kategori: "Salah Cetak",
        materi: "",
        isi: "",
        pelapor: "",
        pekerjaan: "Guru",
        telepon: "",
        email: "",
        lampiran: null,
        domisili: "",
        kota: "",
        tautan: "",
        buku: "",
        jenis_buku: "Buku Teks Utama",
        kelas: "",
        jenjang: "",
        accept_tnc: false,
      },
      file: {
        lampiran: null,
      },
      loading: {
        lampiran: false,
        book: false,
        province: false,
        city: false,
        submit: false,
      },
      link: {
        lampiran: "",
      },
      breadcrumbs: [
        {
          label: "Beranda",
          url: "/",
        },
        {
          label: "Sistem Pengaduan",
          url: "",
        },
      ],
    };
  },
  methods: {
    ...mapActions(["uploadFile"]),
    async fetchBookBySlug(slug) {
      try {
        const response = await axios.get(`https://api.buku.cloudapp.web.id/api/catalogue/getDetails?slug=${slug}`);
        if (response.data && response.data.results) {
          this.bookFromSlug = response.data.results;
          return response.data.results;
        }
      } catch (error) {
        console.error('Error fetching book details:', error);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Gagal mengambil detail buku. Silakan coba lagi.",
        });
      }
      return null;
    },
    showBookPopup(bookTitle) {
      const token = localStorage.getItem("token");
      
      if (!token) {
        // Tidak ada token - user belum login
        Swal.fire({
          icon: "info",
          title: "Login Diperlukan",
          html: `Bapak/Ibu akan melaporkan buku <strong>${bookTitle}</strong>, silahkan login terlebih dahulu pada aplikasi.`,
          confirmButtonText: 'Login Sekarang',
          showCancelButton: true,
          cancelButtonText: 'Batal'
        }).then((result) => {
          if (result.isConfirmed) {
            const currentUrl = encodeURIComponent(this.$route.fullPath);
            this.$router.push(`/login?callback=${currentUrl}`);
          } else {
            // Clear query params if user cancels
            this.$router.replace({ query: {} });
          }
        });
      } else {
        // Ada token - user sudah login
        Swal.fire({
          icon: "success",
          title: "Buku Dipilih",
          html: `Anda akan melaporkan buku <strong>${bookTitle}</strong>. Silakan lengkapi formulir laporan di bawah ini.`,
          confirmButtonText: 'Oke'
        }).then(() => {
          // Scroll to form
          const formElement = document.querySelector('form');
          if (formElement) {
            formElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
      }
    },
    handleJenisBukuChange() {
      // Reset jenjang dan kelas saat jenis buku berubah
      this.report.jenjang = '';
      this.report.kelas = '';
      this.report.buku = '';
      this.books = [];
    },
    async handleBookSlugFromQuery() {
      const bookSlug = this.$route.query.book_slug;
      const token = localStorage.getItem("token");
      
      console.log('Book slug from query:', bookSlug);
      console.log('Token exists:', !!token);
      
      if (bookSlug) {
        console.log('Fetching book data for slug:', bookSlug);
        const bookData = await this.fetchBookBySlug(bookSlug);
        console.log('Book data received:', bookData);
        
        if (bookData) {
          // Tampilkan popup dengan judul buku
          this.showBookPopup(bookData.title);
          
          // Jika ada token (sudah login), auto-fill form
          if (token) {
            // Set jenis buku berdasarkan category dari API
            if (bookData.category) {
              if (bookData.category === 'buku_teks') {
                this.report.jenis_buku = 'Buku Teks Utama';
              } else if (bookData.category === 'buku_sekolah_penggerak') {
                this.report.jenis_buku = 'Buku Teks Pelajaran';
              } else if (bookData.category === 'buku_non_teks') {
                this.report.jenis_buku = 'Buku Nonteks';
              }
              console.log('Auto-filled jenis_buku to:', this.report.jenis_buku);
            }
            
            // Determine jenjang from API level field
            let jenjangToSet = '';
            
            if (bookData.level) {
              const level = bookData.level.toUpperCase().trim();
              
              // For Buku Nonteks, level contains single letter (A, B, C, D, E)
              if (this.report.jenis_buku === 'Buku Nonteks') {
                if (level === 'A') jenjangToSet = 'level_a';
                else if (level === 'B' || level === 'B1' || level === 'B2' || level === 'B3') jenjangToSet = 'level_b';
                else if (level === 'C') jenjangToSet = 'level_c';
                else if (level === 'D') jenjangToSet = 'level_d';
                else if (level === 'E') jenjangToSet = 'level_e';
              } else {
                // For Buku Teks, level contains PAUD, SD, SMP, SMA, etc
                if (level === 'PAUD') jenjangToSet = 'level_paud';
                else if (level === 'SD' || level === 'SD/MI') jenjangToSet = 'level_sd';
                else if (level === 'SMP' || level === 'SMP/MTS') jenjangToSet = 'level_smp';
                else if (level === 'SMA' || level === 'SMK' || level === 'SMA/MA/SMK/MAK') jenjangToSet = 'level_sma';
              }
            }
            
            console.log('Level from API:', bookData.level, '-> Mapped to jenjang:', jenjangToSet);
            
            if (jenjangToSet) {
              // Set flag to prevent watcher from overwriting kelas
              this.skipKelasAutoFill = true;
              
              // Set jenjang to auto-fill the select field
              this.report.jenjang = jenjangToSet;
              console.log('Auto-filled jenjang to:', this.report.jenjang);
              
              // Load books by jenjang first
              await this.getBooksByJenjang(jenjangToSet);
              console.log('Books loaded, total:', this.books.length);
              
              // Auto-fill kelas based on class field from API
              if (bookData.class !== undefined && bookData.class !== null) {
                const kelasAngka = String(bookData.class).trim();
                let kelasRomawi = '';
                
                // Convert numeric class to Roman numerals or handle PAUD
                if (kelasAngka === '' || kelasAngka === '0') {
                  // PAUD default to A
                  kelasRomawi = 'A';
                } else {
                  // Mapping angka ke romawi
                  const kelasMappings = {
                    '1': 'I',
                    '2': 'II',
                    '3': 'III',
                    '4': 'IV',
                    '5': 'V',
                    '6': 'VI',
                    '7': 'VII',
                    '8': 'VIII',
                    '9': 'IX',
                    '10': 'X',
                    '11': 'XI',
                    '12': 'XII'
                  };
                  
                  kelasRomawi = kelasMappings[kelasAngka] || '';
                }
                
                if (kelasRomawi) {
                  // Wait for next tick to ensure jenjang is set first
                  await this.$nextTick();
                  this.report.kelas = kelasRomawi;
                  console.log('Auto-filled kelas to:', this.report.kelas);
                }
              }
              
              // Search and set the book from loaded books list based on title
              if (bookData.title && this.books.length > 0) {
                const foundBook = this.books.find(book => book.title === bookData.title);
                if (foundBook) {
                  await this.$nextTick();
                  this.report.buku = foundBook.title;
                  console.log('Auto-filled buku to:', this.report.buku);
                } else {
                  console.warn('Book not found in loaded books list:', bookData.title);
                }
              }
              
              // Reset flag after a short delay
              setTimeout(() => {
                this.skipKelasAutoFill = false;
              }, 100);
            }
          }
        }
      } else {
        console.log('No book_slug query parameter found');
      }
    },
    async getBooksByJenjang(jenjang) {
      this.loading.book = true;
      try {
        let apiEndpoint = '';
        
        // Determine API endpoint based on jenis_buku
        if (this.report.jenis_buku === 'Buku Teks Utama') {
          apiEndpoint = `${BASE_URL}/api/catalogue/getTextBooks?limit=5000&order_by=updated_at&${jenjang}`;
        } else if (this.report.jenis_buku === 'Buku Teks Pelajaran') {
          apiEndpoint = `${BASE_URL}/api/catalogue/getPenggerakTextBooks?limit=5000&order_by=updated_at&${jenjang}`;
        } else if (this.report.jenis_buku === 'Buku Nonteks') {
          apiEndpoint = `${BASE_URL}/api/catalogue/getNonTextBooks?limit=5000&order_by=updated_at&${jenjang}`;
        }
        
        console.log('Fetching books from:', apiEndpoint);
        
        const res = await axios.get(apiEndpoint);
        if (res.data.status == "success") {
          this.books = res.data.results.map(book => {
            return {
              id: book.id,
              title: book.title,
              slug: book.slug
            };
          });
          console.log('Books fetched:', this.books.length);
        }
      } catch (error) {
        console.error('Error fetching books:', error);
      } finally {
        this.loading.book = false;
      }
    },
    getBooks(event) {
      let jenjang = event.target.value;
      this.getBooksByJenjang(jenjang).then(() => {
        if (this.books.length > 0) {
          this.report.buku = this.books[0].title;
        }
      });
    },
    getCity(province_id) {
      this.loading.city = true
      axios
        .get(`${this.API_LOCATION}/wilayah/kabupaten?api_key=${this.API_KEY}&id_provinsi=${province_id}`,)
        .then((response) => {
          this.report.kota = response.data.value[0].name;
          this.cities = response.data.value;
        })
        .finally(() => {
          this.loading.city = false
        });
    },
    prevSlide() {
      if (this.currentIndex > 0) {
          this.currentIndex--;
      } else {
          this.currentIndex = this.reports.length - 1;
      }
      this.updateTransform();
    },
    nextSlide() {
      if (this.currentIndex < this.reports.length - 1) {
          this.currentIndex++;
      } else {
          this.currentIndex = 0;
      }
      this.updateTransform();
    },
    updateTransform() {
      const slide = document.querySelector('.swiper-slide');
      const swiperWrapper = document.querySelector('.swiper-wrapper');
      if (slide && swiperWrapper) {
        const slideWidth = slide.clientWidth;
        swiperWrapper.style.transform = `translateX(${-this.currentIndex * (slideWidth + 16)}px)`;
      }
    },
    setFile(file) {
      this.file = file;
    },
    uploadingFile() {
      if (this.file === null) {
        Swal.fire({
          icon: "warning",
          title: "Perhatian",
          text: "Lampiran harus terisi.",
        });
      } else {
        if (this.file.size >= 10000000) {
          Swal.fire({
            icon: "warning",
            title: "Perhatian",
            text: "Ukuran berkas terlalu besar, maksimal 10 mb",
          });
        } else {
          this.loading.lampiran = true
          this.uploadFile(this.file)
            .then((res) => {
              if (res.status === "success") {
                this.report.lampiran = res.file;
                Swal.fire({
                  icon: "success",
                  title: "Berhasil",
                  text: "Berkas lampiran berhasil diunggah."
                });
              } else {
                Swal.fire({
                  icon: "error",
                  title: res.message,
                });
              }
            })
            .catch((error) => {
              Swal.fire({
                icon: "error",
                title: error.message,
              });
            })
            .finally(() => {
              this.loading.lampiran = false
            });
        }
      }
    },
    submitReport: _.throttle(function () {
      if (!this.report.accept_tnc) {
        Swal.fire({
          icon: "warning",
          title: "Konfirmasi",
          text: "Sebelum melanjutkan, pelapor harus menyetujui dengan syarat dan ketentuan terlebih dahulu."
        })
        return
      }

      Swal.fire({
        icon: "warning",
        title: "Konfirmasi",
        text: "Apakah anda sudah yakin ingin mengirimkan laporan ini?",
        showCancelButton: true,
        confirmButtonText: 'Sudah, lanjutkan kirim data saya',
        cancelButtonText: "Ok, saya cek kembali",
      }).then((result) => {
        if (result.isConfirmed) {
          let bookId = this.books?.find((book) => book.title == this.report.buku).id          
          var body = new FormData();
          
          body.append("judul", this.report.judul);
          body.append("materi", this.report.materi);
          body.append("isi", this.report.isi);
          body.append("kategori", this.report.kategori);
          body.append("pelapor", this.report.pelapor);
          body.append("pekerjaan", this.report.pekerjaan);
          body.append("telepon", this.report.telepon);
          body.append("email", this.report.email);
          body.append("lampiran", this.report.lampiran);
          body.append("domisili", this.report.domisili);
          body.append("kota", this.report.kota);
          body.append("tautan", this.report.tautan);
          body.append("judul_buku", this.report.buku);
          body.append("id_buku", bookId);
          // body.append("kelas", this.report.kelas);
          // body.append("jenjang", this.report.jenjang);

          this.loading.submit = true
          axios({
            url: BASE_URL + "api/pengaduan/insert",
            method: "POST",
            data: body,
            headers: {
              Authorization: localStorage.getItem("token"),
              "Content-type": "multipart/form-data",
            },
          })
          .then((response) => {
            if (response.data.status == "failed") {
              Swal.fire({
                icon: "error",
                title: "Error",
                text: "Gagal mengirimkan laporan. Tunggu beberapa saat dan coba lagi, atau hubungi admin untuk mengatasi masalah ini.",
              });
            } else {
              Swal.fire({
                imageUrl:
                  "https://ik.imagekit.io/8jggdaymrs/app.buku.kemendikdasmen.go.id/Done.png",
                imageAlt: "Done",
                title: "Terimakasih",
                text: "Laporan telah kami terima. Laporan ini akan sangat bermanfaat untuk kami.",
              }).then((status) => {
                if (status.isConfirmed || status.isDismissed) {
                  this.$router.push(`/sistem-pengawasan/laporan/${response.data.inserted_id}`);
                }
              });
            }
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: error.message,
            });
          })
          .finally(() => {
            this.loading.submit = false
          });
        }
      })
    }, 10000),
  },
  computed: {
    ...mapGetters(['uploadPercentage']), // Mengakses persentase upload dari Vuex
    filteredKelas() {
      const kelasByJenjang = {
        level_paud: ['A', 'B'],
        level_sd: ['I', 'II', 'III', 'IV', 'V', 'VI'],
        level_smp: ['VII', 'VIII', 'IX'],
        level_sma: ['X', 'XI', 'XII']
      };
      return kelasByJenjang[this.report.jenjang] || [];
    },
  },
  watch: {
    // Watcher untuk memantau perubahan jenjang
    'report.jenjang'(newJenjang) {
      // Skip auto-fill if we're setting kelas from API
      if (this.skipKelasAutoFill) {
        return;
      }
      
      const kelasByJenjang = {
        level_paud: ['A', 'B'],
        level_sd: ['I', 'II', 'III', 'IV', 'V', 'VI'],
        level_smp: ['VII', 'VIII', 'IX'],
        level_sma: ['X', 'XI', 'XII']
      };

      // Set kelas default ke urutan pertama sesuai jenjang
      if (kelasByJenjang[newJenjang]) {
        this.report.kelas = kelasByJenjang[newJenjang][0];
      } else {
        this.report.kelas = '';
      }
    }
  },
  async created() {

    axios.get(`${BASE_URL}api/pengaduan`).then((res) => {
      if (res.data.status == "failed") {
        this.notFound = true;
      } else {
        this.reports = res.data.data;
        // console.log(this.reports)
      }
    })

    // fetch total reports from API
    axios.get(`${BASE_URL}api/pengaduan/total`, { headers: { Authorization: localStorage.getItem('token') } }).then((res) => {
      if (res && res.data && res.data.status === 'success') {
        const total = typeof res.data.total === 'number' ? res.data.total : parseInt(res.data.total, 10) || 0;
        this.totalReports = new Intl.NumberFormat('id-ID').format(total);
      }
    }).catch(err => {
      console.error('Failed to fetch total reports', err);
    });

    this.loading.province = true;
    axios({
      method: "get",
      url: this.API_LOCATION + `/wilayah/provinsi?api_key=${this.API_KEY}`,
    }).then((res) => {
      this.provinces = res.data.value;
    }).finally(() => {
      this.loading.province = false;
    });

    const loggedIn = localStorage.getItem("token");
    if (loggedIn) {
      this.isLoggedIn = true
    }
    // Autofill form with user data
    const user = JSON.parse(localStorage.getItem("user"));
    if (user) {
      this.report.pelapor = user.fullname;
      this.report.email = user.email;
    }
  },
  async mounted() {
    this.updateTransform();
    window.addEventListener('resize', this.updateTransform);

    // Handle book_slug query parameter after component is mounted
    console.log('Component mounted, checking for book_slug...');
    console.log('Current route query:', this.$route.query);
    
    await this.$nextTick();
    await this.handleBookSlugFromQuery();
  }
};
</script>

<style scoped>
.sidebar {
  border: 1px solid #dbddf0;
  border-radius: 0.5rem;
  padding: 1rem;
}

/* Progress wrapper */
.progress-wrapper {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 10px;
  background-color: #ffffff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
}

/* Icon style */
.progress-icon {
  font-size: 1.3rem;
  color: #4a90e2;
  margin-right: 15px;
}

/* Progress bar container */
.progress-bar-container {
  flex: 1;
  background-color: #e0e0e0;
  border-radius: 10px;
  overflow: hidden;
  position: relative;
}

/* Progress bar */
.progress-bar {
  height: 20px;
  background-color: #4a90e2;
  border-radius: 10px;
  transition: width 0.4s ease;
}

/* Progress percentage */
.progress-percentage {
  margin-left: 15px;
  font-weight: bold;
  color: #333;
}
</style>